import { useState } from "react";

export const useDonationModal = () => {
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [isDonateReceiptAgreeModalOpen, setIsDonateReceiptAgreeModalOpen] =
    useState(false);
  const [isDonateStep1ModalOpen, setIsDonateStep1ModalOpen] = useState(false);
  const [isDonateStep2ModalOpen, setIsDonateStep2ModalOpen] = useState(false);
  const [agreeChecked, setAgreeChecked] = useState(false);
  const [productId, setProductId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [paymentSelect, setPaymentSelect] = useState("");

  const resetModalState = () => {
    setAgreeChecked(false);
    setIsProductModalOpen(false);
    setIsDonateReceiptAgreeModalOpen(false);
    setIsDonateStep1ModalOpen(false);
    setIsDonateStep2ModalOpen(false);
    setProductId("");
    setPhoneNumber("");
    setPaymentSelect("");
  };

  const startDonationProcess = (id) => {
    setProductId(id);
    setIsProductModalOpen(true);
  };

  return {
    isProductModalOpen,
    isDonateReceiptAgreeModalOpen,
    isDonateStep1ModalOpen,
    isDonateStep2ModalOpen,
    agreeChecked,
    productId,
    phoneNumber,
    paymentSelect,

    setIsProductModalOpen,
    setIsDonateReceiptAgreeModalOpen,
    setIsDonateStep1ModalOpen,
    setIsDonateStep2ModalOpen,
    setAgreeChecked,
    setProductId,
    setPhoneNumber,
    setPaymentSelect,

    resetModalState,
    startDonationProcess,
  };
};
